module.exports = __webpack_public_path__ + "792ae21b5d91566e4d50962bba6eaa82.jpg";